import React, { useState, useEffect } from "react";
import Logo from "./assets/images/logos/logo-rings.svg";
import "./App.css";
import "./utils/i18n-config";
import { LanguageProvider, useLanguage } from "./context/Language";
import { ScrollProvider } from "./context/ScrollContext";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookiePolicy from "./components/CookiePolicy";
import ModerationPolicy from "./components/ModerationPolicy";
import RefundPolicy from "./components/RefundPolicy";
import LegalNotice from "./components/LegalNotice";
import Home from "./components/Home";
import NotFound from "./components/NotFound";
import DeleteAccount from "./components/DeleteAccount";
import Subscribe from "./components/Subscribe";
import GiftPage from "./components/GiftPage";
import ChildSafetyPage from "./components/ChildSafetyPage";
import Withdrawal from "./components/Withdrawal";
import SafetyTipsPage from "./components/SafetyTipsPage";
import { Navigate, useSearchParams, useLocation } from "react-router-dom";
import { isEmbedded } from "./utils/embed";

const SubscribeRoute = () => {
  const [searchParams] = useSearchParams();
  const { localePath } = useLanguage();
  return searchParams.get("gift") === "1" ? (
    <Navigate to={localePath("/gift")} replace />
  ) : (
    <Subscribe />
  );
};

const AppRoutes = () => (
  <>
    <Route index element={<Home />} />
    <Route path="cookie-policy" element={<CookiePolicy />} />
    <Route path="moderation-policy" element={<ModerationPolicy />} />
    <Route path="refund-policy" element={<RefundPolicy />} />
    <Route path="legal-notice" element={<LegalNotice />} />
    <Route path="privacy-policy" element={<PrivacyPolicy />} />
    <Route path="terms-of-service" element={<TermsOfService />} />
    <Route path="delete-account" element={<DeleteAccount />} />
    <Route path="subscribe" element={<SubscribeRoute />} />
    <Route path="gift" element={<GiftPage />} />
    <Route path="child-safety" element={<ChildSafetyPage />} />
    <Route path="withdrawal" element={<Withdrawal />} />
    <Route path="safety-tips" element={<SafetyTipsPage />} />
  </>
);

// Splash loader only on the home page ("/", "/fr", "/ar", "/es", "/it"),
// so deep links (legal pages opened from the app, delete-account, gift) show immediately.
const isHomePath = () =>
  /^\/(en|fr|ar|es|it)?\/?$/.test(window.location.pathname);
if (isEmbedded()) document.documentElement.classList.add("embedded");

const App = () => {
  const [loading, setLoading] = useState(isHomePath);

  useEffect(() => {
    if (!loading) return;
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="app-loading">
          <div className="app-background">
            <img src={Logo} alt="App Logo" className="app-logo" />
          </div>
        </div>
      ) : (
        <ScrollProvider>
          <Router>
            <LanguageProvider>
              <Routes>
                <Route path="/">{AppRoutes()}</Route>
                <Route path="/en">{AppRoutes()}</Route>
                <Route path="/fr">{AppRoutes()}</Route>
                <Route path="/ar">{AppRoutes()}</Route>
                <Route path="/es">{AppRoutes()}</Route>
                <Route path="/it">{AppRoutes()}</Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </LanguageProvider>
          </Router>
        </ScrollProvider>
      )}
    </div>
  );
};

export default App;
